import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FaLock, FaKey } from 'react-icons/fa';
import api from '../services/api';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }

    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const res = await api.put(`/auth/resetpassword/${token}`, { password });
      if (res.data.success) {
        setMessage('Password has been reset successfully. Redirecting to login...');
        setTimeout(() => navigate('/login'), 3000);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password. The link might be expired.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-maroon-dark flex items-center justify-center p-4 pt-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-gold/5 blur-[120px] rounded-full"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-gold/5 blur-[120px] rounded-full"></div>
      </div>

      <div className="w-full max-w-md relative z-10">
        <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-10 border border-gold/10 shadow-2xl">
          <div className="text-center mb-10">
            <h2 className="text-4xl font-serif font-bold text-gold-light mb-2">Reset Password</h2>
            <p className="text-gold-light/50 font-sans font-medium">Enter your new secure password</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gold-light/40 group-focus-within:text-gold transition-colors">
                <FaLock className="h-5 w-5" />
              </div>
              <input
                type="password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="block w-full pl-12 pr-4 py-4 bg-white/5 border border-gold/10 rounded-2xl focus:outline-none focus:ring-2 focus:ring-gold/30 focus:border-gold/40 transition-all text-white placeholder-gold-light/30 font-sans"
                required
                minLength="8"
              />
            </div>
            
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gold-light/40 group-focus-within:text-gold transition-colors">
                <FaKey className="h-5 w-5" />
              </div>
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="block w-full pl-12 pr-4 py-4 bg-white/5 border border-gold/10 rounded-2xl focus:outline-none focus:ring-2 focus:ring-gold/30 focus:border-gold/40 transition-all text-white placeholder-gold-light/30 font-sans"
                required
                minLength="8"
              />
            </div>

            {error && (
              <div className="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-2xl text-sm font-medium font-sans">
                {error}
              </div>
            )}
            
            {message && (
              <div className="bg-green-500/10 border border-green-500/50 text-green-400 px-4 py-3 rounded-2xl text-sm font-medium font-sans">
                {message}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading || message}
              className="w-full h-14 btn-gold !rounded-2xl flex items-center justify-center space-x-3 text-base"
            >
              {isLoading ? (
                <div className="w-6 h-6 border-3 border-white/30 border-t-white rounded-full animate-spin"></div>
              ) : (
                <>
                  <FaKey className="text-xl" />
                  <span>Update Password</span>
                </>
              )}
            </button>
          </form>
          
          {message && (
            <Link
              to="/login"
              className="w-full mt-6 flex items-center justify-center py-4 bg-white/5 border border-gold/10 rounded-2xl text-gold-light font-bold hover:bg-gold/5 transition-all font-sans"
            >
              Return to Login
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
